export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export const toSafeSnakeCase = (str: string): string =>
  str
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip combining diacritics
    .toLowerCase()
    .replace(/[\s-]+/g, '_') // spaces/hyphens → underscore
    .replace(/[^a-z0-9_]/g, '') // remove remaining unsafe chars
    .replace(/_+/g, '_') // collapse consecutive underscores
    .replace(/^_+|_+$/g, '') // trim leading/trailing underscores

export const isNotBlank = (s: string | null | undefined): s is string => !!s && s.trim() !== ''

export const validateEmail = (email: string) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.exec(
    email.toLowerCase(),
  )

export const MENTION_RE = /\{\{\s*([^{}]+?)\s*\}\}/g

export function extractMentions(text: string | undefined | null): string[] {
  if (!text) return []
  const names: string[] = []
  let match
  const re = new RegExp(MENTION_RE.source, 'g')
  while ((match = re.exec(text)) !== null) names.push(match[1].trim())
  return names
}

export type VariableSegment =
  { text: string; isVar: false } | { text: string; isVar: true; deleted: boolean }

export function segmentsToHtml(segments: VariableSegment[]): string {
  return segments.map((s) => (s.isVar && s.deleted ? `<s>${s.text}</s>` : s.text)).join('')
}

export function parseVariableTokens(
  text: string | undefined | null,
  knownNames: Set<string>,
): VariableSegment[] {
  if (!text) return []
  const segments: VariableSegment[] = []
  const re = new RegExp(MENTION_RE.source, 'g')
  let lastIndex = 0
  let match
  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex)
      segments.push({ text: text.slice(lastIndex, match.index), isVar: false })
    const name = match[1].trim()
    segments.push({ text: name, isVar: true, deleted: !knownNames.has(name) })
    lastIndex = re.lastIndex
  }
  if (lastIndex < text.length) segments.push({ text: text.slice(lastIndex), isVar: false })
  return segments
}
